























































































import { Component, Vue } from 'vue-property-decorator';
import { BirthAuth } from '@/api';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';
import PageHeader from '@/components/PageHeader.vue';
import TopFooterButton from '@/components/TopFooterButton.vue';
import TopContentText from '@/components/TopContentText.vue';
import TopContentCautionSingle from '@/components/TopContentCautionSingle.vue';
import { KycOrgConfig } from '@/api/auth';
import { isIncident } from '@/resources/application';

@Component({
  components: {
    PageHeader,
    TopFooterButton,
    TopContentText,
    TopContentCautionSingle
  }
})
export default class InputBirthday extends Vue {
  private isLastLoading: boolean = false;
  private year: number = this.currentYear - 30;
  private month: number = 1;
  private date: number = 1;

  private get isIncident(): boolean {
    return isIncident;
  }

  private get descriptions(): string[] {
    const description: string = this.$t('topInputBirthday.description') as string;
    return this.$store.getters['camera/isPC'] ? [description.replace('<br>', '')] : description.split('<br>');
  }

  // 今年
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // ボタン有効確認
  get enabled(): boolean {
    return this.year > 0 && this.month > 0 && this.date > 0;
  }

  // 次のページへ行く
  private async next(): Promise<void> {
    try {
      this.isLastLoading = true;
      await this.$store.dispatch('auth/storeBirthAuth', {
        year: this.year,
        month: this.month,
        date: this.date
      });

      // 利用規約にすでに同意している
      const checkTermsOfService: KycOrgConfig = this.$store.getters['auth/kycOrgConfigCheckTermsOfService'];
      const agreedTermsOfService: boolean = this.$store.getters['terms/agreedTermsOfService'];
      if (!checkTermsOfService || agreedTermsOfService) {
        this.$router.push('/top/personal-information');
        return;
      }

      this.$router.push({ name: 'terms' });
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    } finally {
      this.isLastLoading = false;
    }
  }
}
